const decodeSlash = (obj) => {
	for (const property in obj) {
		obj[property] = obj[property] ? obj[property].replace("@F0", "/") : "";
	}
	return obj;
};

export default decodeSlash;
